import { inject, Injectable } from '@angular/core';
import { IRemoteError, ISeverityHandler, SeverityHandler, TSeverityCallback } from '@partners/errors';
import { NavigationService } from '@partners/navigation';
import { SettingsMap } from '@partners/settings';
import { EMPTY } from 'rxjs';
import { TGlobalRemoteError } from './global-errors.types';

@Injectable({
  providedIn: 'root'
})
export class GlobalSeverities extends SeverityHandler implements ISeverityHandler {
  override handlers: Map<TGlobalRemoteError, TSeverityCallback>;
  private _navService = inject(NavigationService);

  constructor() {
    super();

    this.handlers = new Map<TGlobalRemoteError, TSeverityCallback>().set('W_0775', (error: IRemoteError) => {
      const { name } = SettingsMap.invalidIssueDateAlert();
      const feature = SettingsMap.get(name);
      this._navService.moveAny(`/${feature.path}`);
      return EMPTY;
    });
  }
}
